import React from 'react';
import { CheckCircle } from 'lucide-react';
import { scrollToTop } from '../utils/scroll';
import { motion } from 'framer-motion';
export function BusinessProblems() {
  const problems = [{
    icon: <CheckCircle size={28} className="text-primary" data-id="element-16" />,
    title: 'The legal intake infrastructure company',
    description: "We've built specialized systems to generate case-ready prospects at scale",
    highlight: true
  }, {
    icon: <CheckCircle size={28} className="text-primary" data-id="element-17" />,
    title: 'Performance-aligned',
    description: 'You only pay for qualified cases, not retainers or vanity metrics',
    highlight: true
  }, {
    icon: <CheckCircle size={28} className="text-primary" data-id="element-18" />,
    title: 'Practice-area specialists',
    description: 'Purpose-built intake systems for immigration (EB-1A) and personal injury (MVA)'
  }, {
    icon: <CheckCircle size={28} className="text-primary" data-id="element-19" />,
    title: 'Exclusive case delivery',
    description: 'One prospect, one attorney. No lead aggregation or reselling'
  }];
  return <section className="w-full px-6 md:px-12 py-24 bg-navy" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-16" data-id="element-22">
          <h2 className="font-display text-xl font-medium text-primary mb-3" data-id="element-23">
            WHAT WE ARE
          </h2>
          <h3 className="font-display text-3xl md:text-4xl font-bold" data-id="element-24">
            Your Legal Intake Infrastructure Partner
          </h3>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-25">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`
                group p-6 md:p-8 rounded-xl border border-white/5 transition-all
                ${problem.highlight ? 'bg-white/5' : 'hover:bg-white/[0.02]'}
              `} data-id="element-26">
              <div className="flex gap-5" data-id="element-27">
                <div className="mt-1 group-hover:scale-110 transition-transform" data-id="element-28">
                  <motion.div whileHover={{
                scale: 1.1
              }} className="relative" data-id="element-29">
                    {problem.icon}
                    <div className="absolute inset-0 bg-primary/20 blur-lg rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-30" />
                  </motion.div>
                </div>
                <div data-id="element-31">
                  <h4 className="font-bold text-lg mb-3" data-id="element-32">{problem.title}</h4>
                  <p className="text-gray-300 leading-relaxed" data-id="element-33">
                    {problem.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-16 text-center" data-id="element-34">
          <button onClick={scrollToTop} className="bg-primary hover:bg-primary-hover text-black font-medium text-sm py-4 px-10 rounded-full transition-all hover:-translate-y-0.5 active:translate-y-0 md:sticky md:bottom-8" data-id="element-35">
            APPLY NOW
          </button>
        </motion.div>
      </div>
    </section>;
}